import { Box } from "@mui/system";
import { Button, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/sharp-duotone-light-svg-icons";
import Modal from "@mui/material/Modal";
import React from "react";
export interface MongoStatisticsModalProps
{
    open: boolean;
    onClose: () => void;
}
export function MongoStatisticsModal( props: MongoStatisticsModalProps )
{
    return (
        <Modal open = {props.open} onClose = {props.onClose}>

            <Box sx = {{ width: "100%", height: "100%", background: "#F1F5F4" }}>
                <Stack direction = "row" spacing = {2} justifyContent = "space-between" alignItems = "center"
                    sx = {{ width: "100%" }}
                >
                    {/* Item to be centered */}
                    <Box sx = {{ flexGrow: 1, textAlign: "center" }}>
                        <Typography variant = "h3">Production Statistics</Typography>
                    </Box>
                    {/* Item to be right-aligned */}
                    <Box>
                        <Button onClick = {() =>
                        {
                            props.onClose();
                        }}
                        >
                            <FontAwesomeIcon icon = {faCircleXmark} size = "2x" fixedWidth/>
                        </Button>
                    </Box>
                </Stack>
                <div style = {{ height: "100%", width: "100%" }} id = "my-dashboard">

                    <iframe

                        style = {{
                            position: "absolute",
                            top: 60,
                            left: 0,
                            background: "#F1F5F4",
                            border: "none",
                            borderRadius: "2px",
                            boxShadow: "0 2px 10px 0 rgba(70, 76, 79, .2)",
                            width: "100%",
                            height: "calc(100% - 60px)",
                            overflowX: "auto",
                            overflowY: "auto",
                        }}
                        src = "https://charts.mongodb.com/charts-project-0-mqnvc/embed/dashboards?id=95b93c53-f86f-4c76-ad2c-5f00e301cf76&theme=light&autoRefresh=true&maxDataAge=3600&showTitleAndDesc=false&scalingWidth=fixed&scalingHeight=fixed"
                    >
                    </iframe>
                </div>

            </Box>
        </Modal>
    );
}
